/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DDiagramCanvasBaseShape } from "./d-diagram-canvas-base-shape";

export interface DDiagramCanvasEditorShape extends DDiagramCanvasBaseShape {}
